import { formatName } from "./format-name.ts";
const NAME_KEYS = new Set([
  "firstName",
  "middleName",
  "lastName",
  "preferredName",
  "consultantName",
  "contactName",
  "primaryContact",
  "accountName",
  "city",
  "state",
]); const PHONE_KEYS = new Set(["phone", "phoneNumber", "contactNumber", "alternateContactNumber", "agencyContactNumber"]);



/** Shared input restrictions for onboarding names and phone numbers. */
export function filterContactInput(key: string, value: string): string {

  if (NAME_KEYS.has(key)) return formatName(value.replace(/[^\p{L}\p{M} .'\u2019-]/gu, ""));

  if (key === "accountNumber") return value.replace(/\D/g, "");
if (key === "routingNumber") return value.replace(/\D/g, "").slice(0, 9);
  if (["beneficiaryName",  "agencyName", "dbaName"].includes(key)) return formatName(value);

if (["dba", "dbaName","businessName","legalCompanyName","title","role"].includes(key))
  return value.replace(/[0-9]/g, "");
if (PHONE_KEYS.has(key)) {
  const filtered = value.replace(/[^0-9+(). -]/g, "");
  const digits = filtered.replace(/\D/g, "");

  if (digits.length > 10) return value.slice(0, -1);

  return filtered;
}

  return value;
}

export function validateEin(value: string): string | undefined {
  const taxId = value.trim();

  if (!taxId) return undefined;

  if (!/^(?:\d{9}|\d{2}-\d{7})$/.test(taxId)) {
    return "Enter a valid EIN.";
  }

  return undefined;
} 
/** Empty values are handled by each form's required-field validation. */
export function contactErrors(values: Record<string, string>): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const [key, raw] of Object.entries(values)) {
    const value = raw.trim();
    if (!value) continue;
    if (NAME_KEYS.has(key) && (!/^[\p{L}\p{M} .'\u2019-]+$/u.test(value) || !/\p{L}/u.test(value))) {
      errors[key] = "Enter a name using letters, spaces, apostrophes or hyphens.";
    }
    if (key === "bankName" && (/\p{N}/u.test(value) || !/\p{L}/u.test(value))) {
      errors[key] = "Enter a valid bank name without numbers.";
    }
    if (key === "routingNumber" && !/^\d{9}$/.test(value)) {
  errors[key] = "Enter a valid 9-digit routing number.";
}
    if (PHONE_KEYS.has(key)) {
      const digits = value.replace(/\D/g, "");
      const indian = key === "contactNumber" || key === "alternateContactNumber";
      if (!/^\+?[0-9(). -]+$/.test(value) || (indian ? !/^\d{10}$/.test(value) : digits.length < 7 || digits.length > 15)) {
        errors[key] = indian ? "Enter a 10-digit contact number." : "Enter a valid phone number with 7?15 digits and an optional leading +.";
      }
    }
  }
  return errors;
}
